import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';
import {EstimatesFilterLookupData} from "../types/EstimatesFilterLookupData";

export const useGetEstimatesFilterLookupData = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['dealer-estimates-filter-lookup-data'],
        refetchOnMount: false,
        queryFn: async () => await apiClient.get(`estimate/dealer-list-filter-lookup-data`) as EstimatesFilterLookupData
    });

    return {
        data,
        isLoading
    };
};
